var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8896 3.61799C28.287 1.68078 26.3843 0.070919 24.5396 0.783632L1.92815 9.51989C-0.131831 10.3158 -0.223618 13.1964 1.7815 14.1218L6.70565 16.3945L9.04813 24.5931C9.16981 25.019 9.50775 25.3488 9.93649 25.4599C10.3652 25.5709 10.8207 25.4469 11.1339 25.1336L14.7423 21.5253L19.7969 25.3163C21.2641 26.4166 23.3774 25.6151 23.7459 23.8185L27.8896 3.61799ZM2.82915 11.8519L25.4406 3.11563L21.2969 23.3163L15.375 18.8748C14.8774 18.5015 14.181 18.551 13.7411 18.9909L12.1956 20.5364L12.66 17.9825L21.7589 8.88367C22.2018 8.44086 22.2485 7.73871 21.8684 7.24104C21.4883 6.74337 20.7986 6.60378 20.2549 6.91448L7.68907 14.0949L2.82915 11.8519ZM9.22121 16.0988L9.97918 18.7518L10.2702 17.1511C10.3157 16.901 10.4364 16.6706 10.6162 16.4909L13.391 13.7161L9.22121 16.0988Z",
    fill: "#0F0F0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.d8d539fff2745ad5f6132e4bce24fd6f.svg";
export { ForwardRef as ReactComponent };